var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.885-488.348q-72.333 0-118.174-45.842-45.842-45.842-45.842-118.174 0-72.333 45.842-118.29 45.841-45.957 118.174-45.957t118.572 45.957q46.239 45.957 46.239 118.29 0 72.332-46.239 118.174-46.239 45.842-118.572 45.842ZM145.869-138.521v-109.145q0-41.678 21.164-72.191 21.164-30.512 54.749-46.361 68.131-30.565 131.303-45.848 63.173-15.282 126.763-15.282 64.674 0 127.239 15.782 62.565 15.783 130.051 45.542 35.038 15.234 56.298 45.759 21.26 30.526 21.26 72.452v109.292H145.869Zm79.218-79.218h509.826v-27.782q0-15.635-9.5-29.835-9.5-14.201-23.5-21.035-61.739-29.304-113.324-40.239-51.584-10.935-108.869-10.935-56.155 0-109.307 10.935t-113.084 40.151q-14.242 6.839-23.242 21.065-9 14.227-9 29.893v27.782Zm254.798-349.828q36.854 0 60.941-23.999 24.087-24 24.087-60.893 0-37.127-23.972-61.03t-60.826-23.903q-36.854 0-60.941 23.929-24.087 23.929-24.087 60.723 0 37.028 23.972 61.101 23.972 24.072 60.826 24.072Zm.115-84.912Zm0 434.74Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/person-4c0340f9.svg";
export { SvgPerson as ReactComponent };